import React from "react"
import "../styles/pageHero.scss"

const PageHero = ({ eyebrow, title, description }) => (
  <div className="page-hero">
    <div className="page-hero__blob page-hero__blob--1" />
    <div className="page-hero__blob page-hero__blob--2" />
    <div className="page-hero__blob page-hero__blob--3" />
    <div className="page-hero__blob page-hero__blob--4" />
    <div className="page-hero__blob page-hero__blob--5" />
    <div className="page-hero__grain" />
    <div className="page-hero__overlay" />
    <div className="page-hero__content">
      {eyebrow && <span className="page-hero__eyebrow">{eyebrow}</span>}
      <h1 className="page-hero__title">{title}</h1>
      {description && <p className="page-hero__desc">{description}</p>}
    </div>
  </div>
)

export default PageHero
